$(function () {
  $('[data-submit-form]').each(function (index, item) {
    $(item).on('click', function (ev) {
      ev.preventDefault();
      saveFormData($(item).attr('data-submit-form'));
    });
  });

  if ($('button[data-submit-form]').length) {
    $(document).on('keydown', function (event) {
      if (event.which == 83 && (event.ctrlKey || event.metaKey)) {
        event.preventDefault();
        $('button[data-submit-form]').trigger('click');
        return false;
      }
      return true;
    });
  }
});

function disableForm() {
  $('.input__submit-button button, .content-header__action--save').attr(
    'disabled',
    'disabled'
  );
}

function enableForm() {
  $('.input__submit-button button, .content-header__action--save').removeAttr(
    'disabled'
  );
}

function addLoadingBars() {
  $('.input__submit-button button').addClass('loading-bar');
}

function removeLoadingBars() {
  $('.input__submit-button button').removeClass('loading-bar');
}

function saveFormData(path) {
  if (app.savingItem) {
    return false;
  }
  var inputData = new FormData();
  var hasFileUpload = false;

  $('[data-form-input]').each(function (index, item) {
    var inputName = $(item).attr('data-form-input');
    var inputType = $(item).attr('data-input-type');

    if (inputType == 'file-upload') {
      var input = $(item).find('.file-input__button');
      var file = input.length && input[0].files ? input[0].files[0] : null;
      if (file) {
        inputData.append(inputName, file);
        hasFileUpload = true;
      }
    } else if (inputType == 'file') {
      // Files
      var value = [];
      $(item)
        .find('.file-input__wrapper')
        .each(function (index, inputWrapper) {
          var id = $(inputWrapper).attr('data-id');

          // Remove
          if (inputWrapper.hasAttribute('data-remove')) {
            inputData.append(
              'delete[' + inputName + '][' + id + ']',
              $(inputWrapper).find('input[data-form-value="id"]').val().trim()
            );
          } else {
            // Get values
            var input = $('input[type="file"][data-id="' + id + '"]');
            var file =
              input.length && input[0].files ? input[0].files[0] : null;
            inputData.append('files[' + id + ']', file);

            if (file) {
              hasFileUpload = true;
            }

            if (inputWrapper.hasAttribute('data-position')) {
              inputData.append(
                inputName + '[' + id + '][position]',
                $(inputWrapper).attr('data-position')
              );
            }

            $(inputWrapper)
              .find('[data-form-value]')
              .each(function (index, input) {
                var fileInputName = $(input).attr('data-form-value');
                switch (fileInputName) {
                  case 'title':
                  case 'alt_title':
                  case 'author':
                  case 'id':
                  case 'media_library_id':
                  case 'replace_id':
                    inputData.append(
                      inputName + '[' + id + '][' + fileInputName + ']',
                      $(input).val().trim()
                    );
                    break;
                  case 'alt_title_enabled':
                    var val =
                      $(input).attr('data-alt-title-enabled') === '1' ? 1 : 0;
                    inputData.append(
                      inputName + '[' + id + '][' + fileInputName + ']',
                      val
                    );
                    break;
                  case 'social_media_enabled':
                    var val =
                      $(input).attr('data-social-media-enabled') === '1'
                        ? 1
                        : 0;
                    inputData.append(
                      inputName + '[' + id + '][' + fileInputName + ']',
                      val
                    );
                    break;
                  case 'consent_available':
                    var val =
                      $(input).attr('data-terms-accepted') === '1'
                        ? 1
                        : 0;
                    inputData.append(
                      inputName + '[' + id + '][' + fileInputName + ']',
                      val
                    );
                    break;
                  case 'tags':
                    inputData.append(
                      inputName + '[' + id + '][' + fileInputName + ']',
                      JSON.stringify($(input).val())
                    );
                    break;
                }
              });
          }
        });
    } else if (inputType == 'multiple-textfields') {
      // Multiple textfields
      var value = [];
      var valueEls = $(item).find('[data-form-value]');

      valueEls.each(function (index, valueEl) {
        if (
          !$(valueEl)[0].hasAttribute('disabled') &&
          $(valueEl).val().trim()
        ) {
          value.push($(valueEl).val().trim());
        }
      });

      if (value && value.length) {
        value = JSON.stringify(value);
      } else {
        value = '';
      }
      inputData.append(inputName, value);
    } else if (inputType == 'title-textarea-html-list') {
      // Multiple textfields and textareas
      var valueContainers = $(
        '.title-textarea-html-list__container:not([data-remove])'
      );

      var value = [];
      $.each(valueContainers, function (index, valueContainer) {
        var titleEl = $(valueContainer).find(
          '[data-form-value][data-value="title"]'
        );
        var contentEl = $(valueContainer).find(
          '[data-form-value][data-value="content"]'
        );

        if (titleEl.length && contentEl.length) {
          var title = titleEl.val().trim();
          var content = contentEl.val().trim();

          if (title || content) {
            value.push({
              title: title,
              content: content
            });
          }
        }
      });

      if (value && value.length) {
        value = JSON.stringify(value);
      } else {
        value = '';
      }
      inputData.append(inputName, value);
    } else if (inputType == 'checkbox') {
      var value = $(item)[0].hasAttribute('data-has-value') ? 1 : 0;
      inputData.append(inputName, value);
    } else {
      // Other values
      var valueEl = $(item).find('[data-form-value]');

      if (!valueEl.length) {
        return;
      }

      valueEl.each(function (index, valueEl) {
        valueEl = $(valueEl);
        var value = valueEl.val();
        var valueType = valueEl.attr('data-form-value');

        if (valueEl.attr('disabled')) {
          value = '';
        } else {
          switch (valueType) {
            case 'date':
              var valueSplit = value.split('.');
              var value = valueSplit[2] + '-';
              value += valueSplit[1] + '-';
              value += valueSplit[0];
              break;
            case 'datetime':
              var valueSplit = value.split(' ');
              var dateSplit = valueSplit[0].split('.');
              var value = dateSplit[2] + '-';
              value += dateSplit[1] + '-';
              value += dateSplit[0] + ' ';
              value += valueSplit[1];
              break;
            case 'lat':
              inputName = 'lat';
              break;
            case 'lng':
              inputName = 'lng';
              break;
          }
        }

        if (Array.isArray(value)) {
          value = JSON.stringify(value);
        }

        inputData.append(inputName, value);
      });
    }
  });

  $.ajax({
    url: path + '/save',
    method: 'post',
    data: inputData,
    processData: false,
    dataType: 'json',
    cache: false,
    enctype: 'multipart/form-data',
    contentType: false,
    headers: {
      'X-CSRF-TOKEN': $('#csrf-token').val()
    },
    beforeSend: function () {
      app.savingItem = true;
      disableForm();
      addLoadingBars();
    },
    success: function (response) {
      removeLoadingBars();
      resetButtonLoadingStatus($('button[data-submit-form]'), 'Speichern');
      if (response && response.success) {
        formSubmitted = true;
        if (!$('[data-form-input="id"] [data-form-value]').val()) {
          window.location.href = path;
        } else {
          if (history.scrollRestoration) {
            history.scrollRestoration = 'manual';
          } else {
            window.onbeforeunload = function () {
              window.scrollTo(0, 0);
            };
          }
          window.location.reload();
        }
        return;
      }
      app.savingItem = false;
      enableForm();
      error();
    },
    error: function (xhr) {
      enableForm();
      removeLoadingBars();
      resetButtonLoadingStatus($('button[data-submit-form]'), 'Speichern');
      app.savingItem = false;

      if (xhr.status == 413 || xhr.status == 419 || xhr.status == 504) {
        var errorText = '';
        var errorDescription = '';
        if (xhr.status == 413) {
          errorText = 'Upload fehlgeschlagen: Dateien sind zu groß';
          errorDescription = 'Eine oder mehrere Ihrer ausgewählten Dateien sind zu groß. Sie können insgesamt bis zu 128 MB hochladen, wobei eine einzelne Datei nicht größer als 64 MB sein darf.';
        }
        if (xhr.status == 419) {
          errorText = 'Ihre Sitzung ist abgelaufen';
          errorDescription = 'Dies kann passieren, wenn Sie längere Zeit inaktiv waren oder wenn ein neues Update der Webseite hochgeladen wurde. Bitte laden Sie die Seite neu, um fortzufahren.';
        }
        if (xhr.status == 504) {
          errorText = 'Serverzeitüberschreitung';
          errorDescription = 'Die Bearbeitung Ihrer Eingaben hat zu lange gedauert. Dies kann passieren, wenn Sie viele Bilder und/oder Dateien hochladen. Verringern Sie die Anzahl der Bilder und Dateien und speichern Sie diese in mehreren Schritten ab.';
        }

        showFormErrors('error', errorText, errorDescription, true);
        animateEl($('.input__submit-button button'), 'shake');
        return;
      }

      try {
        var response = JSON.parse(xhr.responseText);
      } catch (e) {
        return error();
      }

      if (response.errors) {
        $.each(response.errors, function (id, errors) {
          if (errors.length && errors[0] == 'ERROR_FILE') {
            // File error
            var idSplit = id.split('.');
            id = idSplit[0];
            var inputId = idSplit[1];
            var valueId = idSplit[2];

            switch (valueId) {
              case 'title':
                var error = 'Das Feld "Titel" wird benötigt';
                break;
              case 'alt_title':
                var error = 'Das Feld "Alternativtext" wird benötigt';
                break;
              case 'author':
                var error = 'Das Feld "Autor/Copyright" wird benötigt';
                break;
            }
            var wrapper = $('.file-input__wrapper[data-id="' + inputId + '"]');
            wrapper.attr('data-error', '');
            wrapper
              .find('[data-form-value="' + valueId + '"]')
              .addClass('error');
            var errorContainer = wrapper.find('.input__error');
            if (!wrapper.find('[data-error-id="' + valueId + '"]').length) {
              errorContainer.append(
                $('<div data-error-id="' + valueId + '"/>').html(error)
              );
            }
          } else if (errors.length && (errors[0] == 'ERROR_INFECTED' || errors[0] == 'ERROR_BLOCKED')) {
            var wrapper = $('.file-input__wrapper[data-id="' + id + '"]');

            if (id == 'file') {
              wrapper = $('.input__wrapper[data-form-input="file"]');
            }
            wrapper.attr('data-error', '');
            var errorContainer = wrapper.find('.input__error');

            errorContainer.find('[data-error-id="infected"]').remove();

            let errorTxt = 'Diese Datei wurde als infiziert erkannt und kann nicht hochgeladen werden';
            if (errors[0] == 'ERROR_BLOCKED') {
              errorTxt = 'Dieser Dataityp ist nicht erlaubt';
            }

            errorContainer.append(
              $('<div data-error-id="infected"/>').html(errorTxt)
            );
          } else {
            // Other errors
            var inputId = id;
            if (id == 'lat' || id == 'lng') {
              inputId = $('.input__wrapper[data-input-type="lat-lng"]').attr(
                'data-form-input'
              );
            }

            var wrapper = $(
              '.input__wrapper[data-form-input="' + inputId + '"]'
            );
            wrapper.attr('data-error', '');

            var errorContainer = wrapper.find('.input__error');
            errorContainer.html('');

            $.each(errors, function (index, error) {
              errorContainer.append($('<div/>').html(error));
            });
          }
        });

        var errorAmount = Object.keys(response.errors).length;
        showFormErrors(
          'error',
          errorAmount == 1
            ? 'Es ist ein Fehler aufgetreten'
            : 'Es sind ' + errorAmount + ' Fehler aufgetreten'
        );

        animateEl($('.input__submit-button button'), 'shake');
        return;
      }
      ajaxError();
    },
    xhr: function () {
      var myXhr = $.ajaxSettings.xhr();
      if (myXhr.upload) {
        myXhr.upload.addEventListener(
          'progress',
          function (e) {
            if (e.lengthComputable) {
              var percent = Math.floor((e.loaded / e.total) * 100);
              if (percent == 100) {
                resetButtonLoadingStatus(
                  $('button[data-submit-form]'),
                  hasFileUpload ? 'Dateien werden überprüft und optimiert...' : 'Ihre Eingaben werden gespeichert...',
                  true
                );
                addLoadingBars();
              } else {
                var text =
                  '<div class="button__uploading-text">Hochladen... (<span>' +
                  formatBytes(e.loaded, 2) +
                  '</span> / <span>' +
                  formatBytes(e.total, 2) +
                  '</span>) &nbsp;<span>' +
                  percent +
                  '</span>%';
                setButtonLoadingStatus(
                  $('button[data-submit-form]'),
                  text,
                  percent
                );
              }
            }
          },
          false
        );
      }
      return myXhr;
    }
  });
}

function showFormErrors(type, message, description, animateScroll) {
  $('.flash-message__wrapper').remove();
  var flashMessage = $(
    '<div class="flash-message__wrapper flash-message__wrapper--form flash-message__wrapper--' +
    type +
    '"/>'
  );
  flashMessage.html(message);

  if (description) {
    flashMessage.append(
      $('<div class="flash-message__description"/>').html(description)
    );
  }

  flashMessage.insertBefore('.edit__form');
  error(message);

  if ($('[data-error]').length || animateScroll) {
    var firstErrorEl = $($('[data-error]')[0]);
    if (firstErrorEl.length) {
      var offset = $('.content-header__wrapper').outerHeight() + 8;
      var scrollTop = firstErrorEl.offset().top - offset;
    } else {
      scrollTop = 0;
    }

    $('html, body').animate(
      {
        scrollTop: scrollTop
      },
      350
    );
  } else {
    window.scrollTo(0, 0);
  }
}
